<template>
  <sf-table-header
    v-for="(header, headerIndex) in headers"
    :key="headerId(header)"
    :header="header"
    :header-index="headerIndex"
    :sort-direction="sortDirection"
    :sort-by="sortBy"
    class="sf-pointer"
    @headerClick="headerClick"
  >
    <template #header="{ header, headerIndex, headerLabel }">
      <slot
        name="header"
        :header="header"
        :header-index="headerIndex"
        :header-label="headerLabel"
      ></slot>
    </template>
  </sf-table-header>
</template>
<script>
import SfTableHeader from './sf-table-header'
import { tableSortDirections } from './../constants'

export default {
  name: 'SfTableHeaders',
  components: {
    SfTableHeader,
  },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    sortDirection: {
      type: String,
      default: tableSortDirections.ASC,
    },
    sortBy: {
      type: String,
      default: 'age',
    },
  },
  emits: ['headerClick'],
  methods: {
    headerClick(header) {
      this.$emit('headerClick', header)
    },
    headerId(header) {
      return header.id || header
    },
  },
}
</script>
